module.exports = __webpack_public_path__ + "img/Ukraine.a43e6b9b.png";